import { PayloadAction } from '@reduxjs/toolkit'
import { IPartnerState } from 'legacy/lut/features/partner/models'

import { RequestStatus } from 'clickNgo/configs/service/common'
import { IPartner } from 'clickNgo/entities/partner/models'

import { IFetchPartnerParams } from '../models'

export const fetchPartnerByPartnerIdPending = (
  state: IPartnerState,
  action: PayloadAction<unknown, string, { arg: IFetchPartnerParams }>
) => {
  const { meta } = action

  state.partnerData.data = null
  state.partnerData.meta = meta
  state.partnerData.status = RequestStatus.PENDING
  state.partnerData.message = ''
}

export const fetchPartnerByPartnerIdRejected = (
  state: IPartnerState,
  action: PayloadAction<unknown, string, { arg: IFetchPartnerParams }>
) => {
  const { meta } = action

  state.partnerData.meta = meta
  state.partnerData.status = RequestStatus.REJECTED
  state.partnerData.message = action.payload as string
}

export const fetchPartnerByPartnerIdFulfilled = (
  state: IPartnerState,
  action: PayloadAction<IPartner | null, string, { arg: IFetchPartnerParams }>
) => {
  const { meta, payload } = action

  state.partnerData.meta = meta
  state.partnerData.status = RequestStatus.FULFILLED
  state.partnerData.message = ''
  state.partnerData.data = payload
}
